import { Component, HostListener, Input, OnInit } from '@angular/core';
import {
  accreditationProfile,
  menuPermissions,
  programProfile,
  Session
} from "../../../../services/session.service";
import { GenericService } from "../../../../services/generic.service";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: 'app-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    standalone: false
})
export class NavigationMenuComponent implements OnInit {

  @Input() canShowMenu: menuPermissions;


  myWorkOpen: boolean = false;
  libraryOpen: boolean = false;
  analyticsOpen: boolean = false;

  isNewApplicant: boolean = false;
  isAccreditor: boolean = false;
  isFederation: boolean = false;

  projects = [];

  accreditationProfiles: accreditationProfile[];
  programProfiles: programProfile[];
  debug: boolean;

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
      !this.genericService.isDescendant("mainMenu", event.target)  &&
      !event.target.classList.contains("submenu")
    ) {
      this.myWorkOpen = false;
      this.libraryOpen = false;
      this.analyticsOpen = false;
    }
  }
  constructor(
    private session: Session,
    private genericService: GenericService
  ) { }

  ngOnInit() {
    this.isAccreditor = this.session.getUser().userOrganizationData.isAccreditor;
    this.isFederation = this.session.getUser().userOrganizationData.isFederation;
    if(this.session.isNewApplicant() ) {
      this.isNewApplicant = true;
    }
    this.accreditationProfiles = this.session.getInstitutionDirectoryProfiles();
    this.programProfiles = this.session.getProgramInstitutionDirectoryProfiles();
    this.debug = environment.enableDebug;
    this.projects = this.session.getUser().userData.projects;
    console.log(this.projects);
  }

  toggleMyWorkOpen(e) {
    e.preventDefault();
    //this.openLibrarySubMenu = false;
    this.myWorkOpen = !this.myWorkOpen;
    this.libraryOpen = false;
    this.analyticsOpen = false;
    //this.librarySubmenuVisible = false;
    //this.instructionSubmenuVisible = !this.instructionSubmenuVisible;
  }
  toggleLibraryOpen(e) {
    e.preventDefault();
    //this.openLibrarySubMenu = false;
    this.myWorkOpen = false;
    this.libraryOpen = !this.libraryOpen;
    this.analyticsOpen = false;
    //this.librarySubmenuVisible = false;
    //this.instructionSubmenuVisible = !this.instructionSubmenuVisible;
  }
  toggleAnalyticsOpen(e) {
    e.preventDefault();
    //this.openLibrarySubMenu = false;
    this.myWorkOpen = false;
    this.libraryOpen = false;
    this.analyticsOpen = !this.analyticsOpen;
    //this.librarySubmenuVisible = false;
    //this.instructionSubmenuVisible = !this.instructionSubmenuVisible;
  }
}
